import React from 'react';
import { Link } from 'react-router-dom';
import "./css/empty.css";


function Empty() {
    return (
        <div className="empty">
            <h4 className="empty_title">Your shopping cart is empty!</h4>
            <img className="empty_img" src="https://mir-s3-cdn-cf.behance.net/projects/404/95974e121862329.Y3JvcCw5MjIsNzIxLDAsMTM5.png" alt=" " />
            <Link to="/"><button className="empty_btn">Continue Shopping</button></Link>
        </div>
    )
}

export default Empty;
